// Do not modify this file by hand!
// Re-generate this file by running lit-localize.

/**
 * The locale code that templates in this source code are written in.
 */
export const sourceLocale = `en`;

/**
 * The other locale codes that this application is localized into. Sorted
 * lexicographically.
 */
export const targetLocales = [
  `ar`,
  `bg`,
  `cs`,
  `da`,
  `de`,
  `el`,
  `es`,
  `et`,
  `fi`,
  `fr`,
  `hr`,
  `hu`,
  `id`,
  `it`,
  `ja`,
  `ko`,
  `lt`,
  `lv`,
  `nl`,
  `no`,
  `pl`,
  `pt`,
  `pt_BR`,
  `ro`,
  `ru`,
  `sk`,
  `sl`,
  `sr`,
  `sv`,
  `th`,
  `tr`,
  `uk`,
  `uz`,
  `vi`,
  `zh_CN`,
  `zh_HK`,
  `zh_TW`,
] as const;

/**
 * All valid project locale codes. Sorted lexicographically.
 */
export const allLocales = [
  `ar`,
  `bg`,
  `cs`,
  `da`,
  `de`,
  `el`,
  `en`,
  `es`,
  `et`,
  `fi`,
  `fr`,
  `hr`,
  `hu`,
  `id`,
  `it`,
  `ja`,
  `ko`,
  `lt`,
  `lv`,
  `nl`,
  `no`,
  `pl`,
  `pt`,
  `pt_BR`,
  `ro`,
  `ru`,
  `sk`,
  `sl`,
  `sr`,
  `sv`,
  `th`,
  `tr`,
  `uk`,
  `uz`,
  `vi`,
  `zh_CN`,
  `zh_HK`,
  `zh_TW`,
] as const;
